export var getPercent = function (percent) {
    if (percent > 100 || percent < 0) {
        console.warn("[Progress bar]: The value passed to percent or position needs to be a number between 0 and 100 (passed value: " + percent + ").");
    }
    return Math.min(100, Math.max(percent, 0));
};
export var getPosition = function (numCheckpoints, index, hasStepZero) {
    if (hasStepZero)
        return (100 / (numCheckpoints - 1) * index);
    return (100 / numCheckpoints) * (index + 1);
};
export var getNormalizedPosition = function (position, max) { return Math.min(position * 100 / max, 100); };
